import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (cost) =>
    present(
      repository
        .removeCost(cost)
        .then(() => cost)
        .catch(() => Promise.reject(cost)),
    );
}

export type { Interactor };

export { createInteractor };
